import { Action } from '@ngrx/store';

import { PostalResponse } from '@app-model/api';
import { CartItem, CartTaxFormValues, LoadQuote, ValidatedCart } from '@app-model/cart';
import { CheckoutFormValues, LienholderResponse, SubmittedCartItem } from '@app-model/checkout';
import { Forms } from '@app-model/form';

/**
 * When User adds to the cart from the product page
 * call Validations to validate the cart.
 */
export const ADD_CART = '[Cart] ADD CART';
export const DELETE_CART = '[Cart] DELETE CART';
export const ADD_TAXES = '[Cart] ADD_TAXES';
export const ADD_TAXES_SUCCESS = '[Cart] ADD_TAXES_SUCCESS';
export const GET_CUSTOMER_POSTAL = '[Cart] GET CUSTOMER POSTAL';
export const GET_CUSTOMER_POSTAL_SUCCESS = '[Cart] GET CUSTOMER POSTAL SUCCESS';
export const GET_COSIGNER_POSTAL = '[Cart] GET COSIGNER POSTAL';
export const GET_COSIGNER_POSTAL_SUCCESS = '[Cart] GET COSIGNER POSTAL SUCCESS';
export const TOGGLE_COSIGNER_FORM = '[Checkout] TOGGLE COSIGNER FORM';
export const GET_CHECKOUT_FORM = '[Cart] GET CHECKOUT FORM';
export const GET_CHECKOUT_FORM_SUCCESS = '[Cart] GET CHECKOUT FORM SUCCESS';
export const UPDATE_CHECKOUT_FORM = '[Cart] UPDATE CHECKOUT FORM';
export const UPDATE_TAX_FORM_VALUES = '[Cart] UPDATE TAX FORM VALUES';
export const UPDATE_LIENHOLDER_WITH_NEWLY_ADDED = '[Cart] UPDATE LIENHOLDER WITH NEWLY ADDED';
export const SUBMIT_CART = '[Cart] SUBMIT CART';
export const RESET_CART = '[Cart] RESET CART';
export const SUBMIT_CART_SUCCESS = '[Cart] SUBMIT_CART SUCCESS';
export const VALIDATE_CART_SUCCESS = '[Cart] VALIDATE_CART SUCCESS';
export const CART_FAILURE = '[Cart] VALIDATE FAILURE';
export const SAVE_AS_QUOTE = '[Cart] SAVE AS QUOTE';
export const SAVE_AS_QUOTE_SUCCESS = '[Cart] SAVE AS QUOTE SUCCESS';
export const SAVE_AS_QUOTE_FAILURE = '[Cart] SAVE AS QUOTE FAILURE';
export const LOAD_QUOTE = '[Cart] LOAD QUOTE';
export const LOAD_QUOTE_SUCCESS = '[Cart] LOAD QUOTE SUCCESS';

export class AddCartAction implements Action {
  readonly type = ADD_CART;
  constructor(public payload: CartItem) {}
}

export class AddTaxesAction implements Action {
  readonly type = ADD_TAXES;
}

export class AddTaxesSuccessAction implements Action {
  readonly type = ADD_TAXES_SUCCESS;
  constructor(public payload: any) {}
}

export class DeleteCartAction implements Action {
  readonly type = DELETE_CART;

  constructor(public payload: { key: string }) {}
}

export class SubmitCartAction implements Action {
  readonly type = SUBMIT_CART;

  constructor(public payload: any) {}
}

export class AddAndValidateCartSuccessAction implements Action {
  readonly type = VALIDATE_CART_SUCCESS;

  constructor(public payload: { validatedCart: ValidatedCart }) {}
}

export class GetCustomerPostalAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL;

  constructor(public payload: string) {}
}

export class GetCustomerPostalSuccessAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL_SUCCESS;

  constructor(public payload: PostalResponse) {}
}

export class GetCosignerPostalAction implements Action {
  readonly type = GET_COSIGNER_POSTAL;

  constructor(public payload: string) {}
}

export class GetCosignerPostalSuccessAction implements Action {
  readonly type = GET_COSIGNER_POSTAL_SUCCESS;

  constructor(public payload: PostalResponse) {}
}

export class ToggleCosignerFormAction implements Action {
  readonly type = TOGGLE_COSIGNER_FORM;

  constructor(public payload: boolean) {}
}

export class GetCheckouFormAction implements Action {
  readonly type = GET_CHECKOUT_FORM;
}

export class GetCheckouFormSuccessAction implements Action {
  readonly type = GET_CHECKOUT_FORM_SUCCESS;

  constructor(public payload: Forms) {}
}

export class UpdateCheckoutFormAction implements Action {
  readonly type = UPDATE_CHECKOUT_FORM;

  constructor(public payload: CheckoutFormValues) {}
}

export class UpdateLienholderWithNewlyAddedAction implements Action {
  readonly type = UPDATE_LIENHOLDER_WITH_NEWLY_ADDED;

  constructor(public payload: LienholderResponse) {}
}

export class UpdateTaxFormValuesAction implements Action {
  readonly type = UPDATE_TAX_FORM_VALUES;

  constructor(public payload: CartTaxFormValues[]) {}
}

export class SubmitCartSuccessAction implements Action {
  readonly type = SUBMIT_CART_SUCCESS;

  constructor(public payload: { invalidCart: CartItem[]; submittedCart: SubmittedCartItem[] }) {}
}

export class SaveAsQuoteAction implements Action {
  readonly type = SAVE_AS_QUOTE;
}

export class LoadQuoteAction implements Action {
  readonly type = LOAD_QUOTE;
}

export class LoadQuoteSuccessAction implements Action {
  readonly type = LOAD_QUOTE_SUCCESS;
  constructor(public payload: LoadQuote) {}
}

export class CartFailureAction implements Action {
  readonly type = CART_FAILURE;

  constructor(public payload: any) {}
}

export class ResetCartAction implements Action {
  readonly type = RESET_CART;
}

export type All =
  | AddCartAction
  | SubmitCartAction
  | DeleteCartAction
  | SubmitCartSuccessAction
  | AddAndValidateCartSuccessAction
  | CartFailureAction
  | GetCheckouFormSuccessAction
  | ResetCartAction
  | LoadQuoteSuccessAction
  | GetCosignerPostalSuccessAction
  | GetCustomerPostalSuccessAction
  | UpdateCheckoutFormAction
  | ToggleCosignerFormAction
  | UpdateLienholderWithNewlyAddedAction
  | UpdateTaxFormValuesAction
  | AddTaxesAction
  | AddTaxesSuccessAction;
